import React, { useEffect, useRef, useState } from "react";
import * as ChartGeo from "chartjs-chart-geo";
import { mapData } from "../../data/states-10m.ts";
import {
  Chart as ChartJS,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import type { Feature } from "chartjs-chart-geo";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  ChartGeo.ChoroplethController,
  ChartGeo.ProjectionScale,
  ChartGeo.ColorScale,
  ChartGeo.GeoFeature,
);

export default function ChoroplethUS({
  data,
}: {
  data: { [key: string]: number } | undefined;
}) {
  const [nation, setNation] = useState<Feature | undefined>();
  const [states, setStates] = useState<Feature[] | undefined>();
  const canvas2 = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!data) {
      return;
    }

    const nationFeat = ChartGeo.topojson.feature(
      mapData,
      mapData.objects.nation,
    );
    const nationRes =
      nationFeat.type !== "Feature" ? nationFeat.features[0] : nationFeat;
    const statesFeat = ChartGeo.topojson.feature(
      mapData,
      mapData.objects.states,
    );
    const statesRes =
      statesFeat.type !== "Feature" ? statesFeat.features : [statesFeat];

    setNation(nationRes);
    setStates(statesRes);
  }, [data]);

  useEffect(() => {
    const canvas: HTMLCanvasElement | null = document.getElementById(
      "canvas",
    ) as HTMLCanvasElement;
    if (!data || !nation || !states || !canvas) {
      return;
    }
    const chart = new ChartJS(canvas.getContext("2d")!, {
      type: "choropleth",
      data: {
        labels: states.map((d) => d.properties.name),
        datasets: [
          {
            label: "States",
            outline: nation,
            data: states.map((d) => {
              const currState = d.properties.name;
              return {
                feature: d,
                value: data[currState],
              };
            }),
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xy: {
            axis: "x",
            projection: "albersUsa",
            display: false,
          },
          color: {
            axis: "x",
            display: true,
            interpolate: "oranges",
            missing: "#fcfcfc",
            quantize: 100,
            legend: {
              position: "bottom-right",
              align: "bottom",
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    });
    return () => {
      chart.destroy();
    };
  }, [nation, states, data]);

  return <canvas ref={canvas2} id="canvas"></canvas>;
}
